import { render } from "./Form.vue?vue&type=template&id=b7d6f7be&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=b7d6f7be&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b7d6f7be"

export default script